import Page from '@/features/dashboard/packages/pages/Package/Desktop'

export default Page
